import { createFileRoute, useParams } from '@tanstack/react-router';
import { JourneysDataIndexItemHandoff } from '@/pages/workspaces/data-index/routing';
import { DataIndexItemResolver } from '@/pages/workspaces/data-index/data-index-item-resolver';
import { LastWorkspaceResolver } from './-route-helpers';

/** The `journeys` spelling of a person attribute's or event's own page. */
function JourneysDataIndexItemRoute() {
  const { type, itemId } = useParams({
    from: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/',
  });

  return (
    <LastWorkspaceResolver>
      <DataIndexItemResolver segment={type} itemId={itemId}>
        {(address) => <JourneysDataIndexItemHandoff address={address} />}
      </DataIndexItemResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/')({
  component: JourneysDataIndexItemRoute,
});
